var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"EmptyList"},[_c('h4',[_vm._v(_vm._s(_vm.props.text || 'Nie znaleziono danych'))]),_c('i',{staticClass:"fa",class:[_vm.props.icon ? _vm.props.icon : 'fa-eye-slash'],attrs:{"aria-hidden":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }